import React from 'react';
import classNames from 'classnames';

import css from './IconWifi.module.css';

export const IconWifi = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <title />
      <path
        d="M332.41 310.59a115 115 0 0 0-152.8 0M393.46 249.54a201.26 201.26 0 0 0-274.92 0"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 32,
        }}
      />
      <path
        d="M447.72 182.11a288 288 0 0 0-383.44 0"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 32,
        }}
      />
      <path d="M256 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32Z" />
    </svg>
  );
};

export default IconWifi;
